import IM from './im';

export default IM;


// WEBPACK FOOTER //
// ./node_modules/_@ali_im-sdk-third@0.1.8@@ali/im-sdk-third/lib/index.js